const TieMeKangarooDownSport = [
	'[Intro]',
	"There's an old Australian stockman, lying, dying.",
	'And he gets himself up on to one elbow and he turns to his mates,',
	"who are gathered 'round him and he says",
	'',
	'[Verse 1]',
	"Watch me wallaby's feed, mate. Watch me wallaby's feed.",
	"They're a dangerous breed, mate. So watch me wallaby's feed.",
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'',
	'[Verse 2]',
	'Keep me cockatoo cool, Curl. Keep me cockatoo cool.',
	"Uh, don't go acting the fool, Curl. Just keep me cockatoo cool.",
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'',
	'[Verse 3]',
	"'n' take me koala back, Jack. Take me koala back.",
	'He lives somewhere out on the track, Mac. So take me koala back.',
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'',
	'[Verse 4]',
	'Let me *mongoose go loose, Lou. Let me mongoose go loose.',
	"He's of no further use, Lou. So let me mongoose go loose.",
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'',
	'[Verse 5]',
	'And mind me platypus duck, Bill. Mind me platypus duck.',
	"Ah, Don't let 'im go running amok, Bill. Just mind me platypus duck.",
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'',
	'[Verse 6]',
	'Play your didgeridoo, Blue. Play your didgeridoo.',
	"Ah, like, keep playing 'til I shoot through, Blue",
	'Play your didgeridoo.',
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'',
	'[Verse 7]',
	"Tan me hide when I'm dead, Fred. Tan me hide when I'm dead.",
	"So we tanned his hide when he died, Clyde. And that's it hanging on the shed.",
	'',
	'[Chorus]',
	'All together now',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
	'Tie me kangaroo down, sport. Tie me kangaroo down.',
];

export default TieMeKangarooDownSport;
